import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';

import { fetchText } from 'store/Admin/Analyser/features';

export const useAdminTextRegenerationStatus = ({
  textId,
  startChecking,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
  isLoading,
  isError,
  t,
}) => {
  const dispatch = useDispatch();

  const [regenerateLoading, setRegenerateLoading] = useState(false);

  useEffect(() => {
    let intervalId;

    const checkStatus = async () => {
      try {
        if (!isLoading && !isError) {
          const response = await axiosPrivate.get(
            `/texts/${textId}/getTextRegenerationJobStatus`
          );

          switch (response.data) {
            case 'PROCESSING':
              setRegenerateLoading(true);
              break;
            case 'FAILED':
              setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
              setIsSuccess(false);
              setErrorSuccess(true);
              setRegenerateLoading(false);
              clearInterval(intervalId);
              break;
            case 'UNKNOWN':
              setRegenerateLoading(false);
              clearInterval(intervalId);
              break;
            case 'COMPLETED':
              clearInterval(intervalId);
              dispatch(fetchText(textId));
              setRegenerateLoading(false);
              break;
            default:
              break;
          }
        }
      } catch (error) {
        console.error('Error checking status:', error);
        clearInterval(intervalId);
      }
    };

    checkStatus();
    intervalId = setInterval(checkStatus, 60000);

    return () => clearInterval(intervalId);
  }, [startChecking]);

  return {
    regenerateLoading,
  };
};
